import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnChanges, OnInit, output, SimpleChanges } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SystemAdminService } from "../../../../services/system-admin.service";
import { ActivatedRoute } from "@angular/router";
import { ProductStateApprovedListResponse } from "../../../../models/SystemAdmin.model";


@Component({
    selector: 'app-product-sl-details-list',
    standalone: true,
    imports: [CommonModule, MatExpansionModule, MatTableModule ],
    templateUrl: './product-sl-details-list.component.html',
    styleUrl: './product-sl-details-list.component.scss'
})
export class ProductSlDetailsListComponent implements OnChanges{
  @Input() productSlDetailsList!: ProductStateApprovedListResponse[];
  displayedColumns: string[] = ['#', 'approvedProducts', 'stateId', 'personalLicenseHeld', 'slLicenseNumber', 'slLicenseExpiryDate', 'action']; // Columns to display
  dataSource = new MatTableDataSource<any>();
  removeApprovedProductEmitter = output<number>();
  activateRoute = inject(ActivatedRoute);
  systemAdminService = inject(SystemAdminService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['productSlDetailsList']) {
      // Detect changes in the input data and react to it
      this.dataSource.data = this.productSlDetailsList;
      
    }
  }
  
  onRemoveApprovedProduct(approvedId: number) {
    this.removeApprovedProductEmitter.emit(approvedId);
  }
}